<template>

    <div class="container-fluid">
        <div class="container-fluid">
                <div class="row d-flex justify-content-between">
                <div class="col-8">
                    <span v-if="userData.logo!=0"><img :src="getFiles(userData.logo)" height="50"/></span>
                    <span v-else><img src="@/assets/images/logo.png" height="50"/></span>
                    <br>
                    <h4 style="color:black" class="text-uppercase">{{ userData.business }}</h4>
                    <span style="color:black;font-size:13px">Location : {{ userData.location }}</span><br>
                    <span style="color:black;font-size:13px">Telephone : {{ userData.contact }}</span><br>
                    <span style="color:black;font-size:13px">Email : {{ userData.email }}</span><br>
                    <span style="color:black;font-size:13px">Website : {{ userData.website }}</span><br>
                    <span v-if="userData.slogan" style="color:black;font-size:13px;font-style:italic">Slogan: {{ userData.slogan }}</span><br>
                </div>
                <div class="col-4">
                    <img class="img-rounded" src="@/assets/images/sick.png" height="40px" /><br>
                    <table v-for="item in patients" :key="item.id" class="table" density="compact" style="color:black">
                      
                   <tr><td>Full Name</td><td> {{ item.name }}</td></tr>
                    <tr><td>Gender</td><td> {{ item.gender }} </td></tr>
                    <tr><td> Telephone </td><td> {{ item.telephone }} </td></tr>
                    <tr><td> Date of Birth </td><td> {{ item.date_of_birth }} </td></tr>
                    <tr><td> Address </td><td> {{ item.address }} </td></tr>
                  
                    </table>
                 
                    <h5 class="my-3"><i class="mdi mdi-calendar">Visit date</i> &nbsp;&nbsp; {{ visit_date }}</h5>
                </div> 
          
            </div>
        </div>
        <div class="px-0 shadow" v-for="item in consentform" :key="item.id" >
              <div class="card-header ">
                <h4 class="mt-2 text-center text-decoration-underline">CONSENT FORM</h4>
              </div>
              <div class="card-body ">
                I <b > {{ item.patient.name }}</b>
                  consent for   <b>{{ item.service.name }}</b> procudure
                
               
                to be done to me owing to my health condition.

                <br><br>
                I accept administration of the relevant drugs and anesthesia as explained by the doctor to aid the procedure. <br><br>

                <!-- I accept to pay a fee of <b >{{ item.service.serviceprice }}</b>    (<b>{{ moneyToWords(item.service.serviceprice) }}</b>) as the cost for the procedure.
      as the cost for the procedure.   -->
      I accept to pay a fee of <b>{{ item.prices }}</b> (<b>{{ moneyToWords(item.prices) }}</b>) as the cost for the procedure.
 
              
              </div>
              
                {{ date }}
              <div class="card-footer  ">
                <div class="mt-3 text-center">
                  <h5 style="color: black;" class="my-4 text-center">Signed By:</h5>
                  <h5 style="color: black;" class="my-4 text-center">Patient : .........................</h5>
                  <h5 style="color: black;" class="my-4 text-center"> <b>{{ item.witness }}</b> as the Witness : .........................</h5>
                  <!-- <h5 style="color: black;" class="my-4 text-center"> <span v-html="witness" style="line-height: 10px;"></span> as the Witness : .........................</h5> -->
                  <p style="color:black;font-size:13px">Printed by : {{ userData.username }} <br>  Via Afrimed Software | www.afrimed.com </p>
                </div>
              </div>
          </div>
    </div>
      </template>
      
      <script>
      import axios from "axios";
      export default {
        data() {
          return {
            patients:[],
            patientconsentforms:[],
            patientspinner:true,
            consentformspinner:true,
            userData: JSON.parse(localStorage.getItem("user")),
            id:'',
            service_price:'',
            discharge_date:new Date().toLocaleDateString('fr-CA'),
            service_name:'',
            visit_date:"",
            date:'',
            patientid:'',
            patient_id:'',
            service:'',
            consentforms:[],
            witness:'',
            patient:[],
            name:'',
            price:'',
            consentform:[],
            servicePriceInWords: '',
            prices:'',
                                 
          };
        },
        created() {
         this.fetchInfo();
         this.showconsentform();
      
       
    
        },
        mounted() {
           
          setTimeout(() => {
            window.print();
            window.onafterprint=this.$router.go(-1);
        }, 5800);
        } ,
        methods: {
         getFiles(name){
            let url = axios.defaults.baseURL;
            let imagelink = (url).slice(0,-3)+"logos/"+name;
            return imagelink;
          },
          async fetchInfo(){
            this.id=this.$route.query.id;
            let url = `/visitinfo/${this.id}`;
            await axios.get(url).then((response) => {
              this.visitid = response.data.visits[0].visit_id;
              this.service = response.data.visits[0].service_name.name;
              this.service_id = response.data.visits[0].service_name.id;
              this.visit_date = response.data.visits[0].addedon;
              this.showpatient();
              this.showconsentform();
            });
          },
          async showpatient(){
            this.patientid=this.$route.query.patient_id;
  
            let url = `/patientprofile/${this.patientid}`;
            await axios.get(url).then((response) => {
             
              this.patients = response.data.patients;
              this.patientspinner=false;
             
  
            });
          },
          
   
          

async showconsentform() {
      this.id = this.$route.query.id;
      let url = `/printpatientconsentform/${this.id}`;
      const response = await axios.get(url);
      this.consentform = response.data.consentforms;
      },
  
      moneyToWords(value){
        const toWords = (num)=> {
          const ones = ['','one','two','three','four','five','six','seven','eight','nine'];
          const teens = ['eleven','twelve','thirteen','fourteen','fifteen','sixteen','seventeen','eighteen','nineteen'];
          const tens = ['','ten','twenty','thirty','forty','fifty','sixty','seventy','eighty','ninety'];

          const convert = (num) => {
            if (num  < 10)
            return ones[num];
            
            if (num  < 20)
            return teens[num  - 11];

            if (num  < 100)
            return tens[Math.floor(num  / 10)] + (num  % 10 !== 0 ? ' ' + ones[num  % 10] : '');

            if (num  < 1000)
            return ones[Math.floor(num  / 100)] + ' hundred' + (num  % 100 !== 0 ? ' and ' + convert(num  % 100) : '');

            if (num  < 1000000)
            return convert(Math.floor(num  / 1000)) + ' thousand' + (num  % 1000 !== 0 ? ' ' + convert(num  % 1000) : '');

            if (num  < 1000000000)
            return convert(Math.floor(num  / 1000000)) + ' million' + (num  % 1000000 !== 0 ? ' ' + convert(num  % 1000000) : '');

        };

        if (num  === 0)
        return 'zero';
      return convert(num);
    };
   
return toWords(value);
    },

  },
 
      };
      </script>

   